import React, {Fragment, useEffect, useState} from 'react'
import {getGnOrder, reqGnOrderReasons, reqGnDelivery,} from '../../api'
import {Form, message, Tooltip, Row, Col,} from 'antd';

import GnDeliveryStep from '../../components/gnStep/gn-delivery-step'
import '../domestic-order/domestic.less'
import GnOrderDeliveryFile from './gn-order-delivery-file';
import {DEMESTIC_ORDER_STATUS, IN_PERSON} from "../../utills/constants";
import {setDefaultAddrFlag} from "../../utills/common";


export default function DomesticOrderDetail(props) {
    const [order, setOrder] = useState({});
    const [delivery, setDelivery] = useState({});
    const [startAdressPos, setStartAdressPos] = useState([]);
    const [endAdressPos, setEndAdressPos] = useState([]);
    //数据源
    const [gnOrderReason, setGnOrderReason] = useState([]);
    useEffect(() => {
        if (props.location.state) {
            const orderId = props.location.state.orderId;
            if (orderId) {
                getOrder(orderId)
                const a = getOrder(orderId)
                Promise.all([a]).then(() => {
                    getDelivery(orderId)
                })
                getGnOrderReason(orderId)
            }
        }
    }, []);
    const getOrder = async (id) => {
        let result = await getGnOrder(id)
        if (result.code === 200) {
            const data = {...result.data};
            setDefaultAddrFlag(data.startAdressPos, data.originCity)
            setStartAdressPos(data.startAdressPos)
            setDefaultAddrFlag(data.endAdressPos, data.destinationCity)
            setEndAdressPos(data.endAdressPos)
            setOrder(data);
        } else {
            message.error(result.message)
        }
    }
    const getDelivery = async (id) => {
        let result = await reqGnDelivery(id)
        if (result.code === 200) {
            if (result.data) {
                setDelivery(result.data);
            }
            const data = result.data;
            setDelivery(data);
        } else {
            message.error(result.message)
        }
    }
    const getGnOrderReason = async (id) => {
        let result = await reqGnOrderReasons(id, "failed")
        if (result.code === 200) {
            setGnOrderReason(result.data);
        } else {
            message.error(result.message)
        }
    }
    const items = (gnOrderReason || []).map((o, i) => {
        if (o) {
            return <span>
                <span>{o.optDt} <br/></span>
                <span>{o.reason}<br/></span>
          </span>
        }
    });
    const description = (data) => {
        let description = '';
        if (data != null) {
            data.forEach((value, i) => {
                if (value === 'other') {
                    value = order.goodsName
                }
                if (i === data.length - 1) {
                    description = description + value
                } else {
                    description = description + value + ' / '
                }

            })
        }
        return description;
    }
    return (
        <div className='order-info info box-shadow padding-20'>
            <div className="head-title">
                <span className='title'>国内运输订单详情</span>
            </div>
            <div className="order-info-details">
                <Row className='order-info-item'>
                    <Col span={8}>
                        <span className='label'>订单编号 : </span>
                        <span>{order.orderNo}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>审核记录 : </span>
                        {gnOrderReason.length === 0 ? <span>0条</span> :
                            <Tooltip placement="rightBottom" title={<span>{items}</span>}>
                                <span>{gnOrderReason.length}条</span></Tooltip>}
                    </Col>
                    <Col span={8}>
                        <span className='label'>当前订单状态 : </span>
                        <span>{DEMESTIC_ORDER_STATUS[order.orderStatus]}</span>
                    </Col>
                </Row>
            </div>
            <div>
                <div className="address-box">
                    <div className="start-add-text list">
                        <div className="left">起</div>
                        <div className="right">
                            {startAdressPos.map((o, i) => {
                                return <div className="iteam">
                                    <div className="xh">地址{i + 1}：<br/>{o && o.default ? '(默认)' : ''}</div>
                                    <div className="text">
                                        <div>{o.province} / {o.city} {o.address}</div>
                                        <div>{o.contactName} / {o.contackPhone}</div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className="end-add-text list">
                        <div className="left">终</div>
                        <div className="right">
                            {endAdressPos.map((o, i) => {
                                return <div className="iteam">
                                    <div className="xh">地址{i + 1}：<br/>{o && o.default ? '(默认)' : ''}</div>
                                    <div className="text">
                                        <div>{o.province} / {o.city} {o.address}</div>
                                        <div>{o.contactName} / {o.contackPhone}</div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
                <div className='flex-between'>
                    <div className="with-auto">
                        <h3> 基础信息</h3>
                        <div className='domestic-box'>
                            <div className="detail-box">
                                <div className="grid-10">
                                    <div className="D-head">
                                        <div className="name">需求信息</div>
                                    </div>
                                    <div className="D-body">
                                        <div className="iteam-text">
                                            <div className="lable">车型：</div>
                                            <div>{order.vehicleType}</div>
                                        </div>
                                        <div className="iteam-text">
                                            <div className="lable">预计提货时间：</div>
                                            <div>{order.deliveryEstimateDt}</div>
                                        </div>
                                        <div className="iteam-text">
                                            <div className="lable">保险：</div>
                                            <div>{IN_PERSON[order.insureFeeType]}</div>
                                        </div>
                                        <div className="iteam-text">
                                            <div className="lable">货物类型：</div>
                                            <div>{description(order.goodsTypes)}</div>
                                        </div>
                                        <div className="iteam-text">
                                            <div className="lable">包装方式：</div>
                                            <div>{description(order.packageTypes)}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid-10">
                                    <div className="D-head">
                                        <div className="name"><i>*</i>车辆信息</div>
                                    </div>
                                    <div className="D-body">
                                        <div className="iteam-text">
                                            <div className="iteam-text">
                                                <div className="lable">车牌：</div>
                                                <div>{delivery.vehicleNo}</div>
                                            </div>
                                        </div>
                                        <div className="iteam-text">
                                            <div className="lable">车挂：</div>
                                            <div>{delivery.hangNo}</div>
                                        </div>
                                        <div className="iteam-text">
                                            <div className="lable">司机1：</div>
                                            <div>
                                                <div>{delivery.driverName} {delivery.phone}</div>
                                                <div>{delivery.identification}</div>
                                            </div>
                                        </div>
                                        <div className="iteam-text">
                                            <div className="lable">司机2：</div>
                                            <div>
                                                <div>{delivery.driverName2} {delivery.phone2}</div>
                                                <div>{delivery.identification2}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid-5">
                                    <div className="D-head">
                                        <div className="name"><i>*</i>装车照</div>
                                    </div>
                                    <GnOrderDeliveryFile orderId={props.location.state.orderId}
                                                         fileType={'gn_loading_license'}/>
                                </div>
                                <div className="grid-5">
                                    <div className="D-head">
                                        <div className="name"><i>*</i>发车照</div>
                                    </div>
                                    <GnOrderDeliveryFile orderId={props.location.state.orderId}
                                                         fileType={'gn_departure_license'}/>
                                </div>
                                <div className="grid-5">
                                    <div className="D-head">
                                        <div className="name"><i>*</i>抵达照</div>
                                    </div>
                                    <GnOrderDeliveryFile orderId={props.location.state.orderId}
                                                         fileType={'gn_arrive_license'}/>
                                </div>
                                <div className="grid-5"></div>
                                <div className="grid-3">
                                    <div className="D-head">
                                        <div className="name"><i>*</i>预计抵达时间</div>

                                    </div>
                                    <div className="D-body">
                                        <div className="text-list">
                                            {delivery.estimateArriveDt}
                                        </div>
                                    </div>
                                </div>
                                <div className="grid-3">
                                    <div className="D-head">
                                        <div className="name">铅封号</div>
                                    </div>
                                    <div className="D-body">
                                        <div className="text-list">
                                            {delivery.sealNo}
                                        </div>
                                    </div>
                                </div>
                                <div className="grid-3">
                                    <div className="D-head">
                                        <div className="name">过磅重量(KG)</div>
                                    </div>
                                    <div className="D-body">
                                        <div className="text-list">
                                            {delivery.weight}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{width: '35%', marginLeft: '10px'}}>
                        <h3> 路由信息</h3>
                        <div className='domestic-box'>
                            <div style={{marginLeft: '35px'}}>
                                <GnDeliveryStep orderId={order.id} orderStatus={order.orderStatus} getOrder={getOrder}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}